module.exports = __webpack_public_path__ + "img/br11.ed45dcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br11.jpg
// module id = 8a4v
// module chunks = 0